import { ReportColumnNames } from '@spa/api';

import {
    ReportTableColumn,
    ReportTableConfigInterface,
    ReportTableGroupedColumn
} from '../../../app/shared/components/report-table';

export const TotalsByEntitiesReportTableConfig = (): ReportTableConfigInterface => {
    return {
        rows: [],
        columns: [
            new ReportTableColumn({
                label: 'Group',
                selector: ReportColumnNames.Account,
                sortIndex: 1
            }),
            new ReportTableColumn({
                label: '',
                selector: ReportColumnNames.Currency,
                sortIndex: 2
            }),
            new ReportTableColumn({
                label: '',
                selector: ReportColumnNames.AssetType,
                sortIndex: 3
            }),
            new ReportTableColumn({
                label: 'Orders',
                selector: ReportColumnNames.Orders,
                sortIndex: 4
            }),
            new ReportTableColumn({
                label: 'Fills',
                selector: ReportColumnNames.Fills,
                shifted: true,
                sortIndex: 5
            }),
            new ReportTableColumn({
                label: 'Qty',
                selector: ReportColumnNames.Qty,
                shifted: true,
                sortIndex: 6
            }),
            new ReportTableGroupedColumn({
                selector: 'StartBalance',
                label: 'Start Balance',
                childColumns: [
                    new ReportTableColumn({
                        label: 'Cash',
                        selector: ReportColumnNames.PreviousCash
                    }),
                    new ReportTableColumn({
                        label: 'Unrealized',
                        selector: ReportColumnNames.PreviousUnrealized
                    })
                ],
                sortIndex: 7
            }),
            new ReportTableColumn({
                label: 'Gross',
                selector: ReportColumnNames.Gross,
                shifted: true,
                sortIndex: 8
            }),
            new ReportTableGroupedColumn({
                label: 'All Trade Fees',
                selector: 'TradeFees',
                childColumns: [
                    new ReportTableColumn({
                        label: 'Comm',
                        selector: ReportColumnNames.COMM,
                        shifted: true
                    }),
                    new ReportTableColumn({
                        label: 'Ecn Fee',
                        selector: ReportColumnNames.ECNFee,
                        shifted: true
                    }),
                    new ReportTableColumn({
                        label: 'Sec',
                        selector: ReportColumnNames.SEC,
                        shifted: true
                    }),
                    new ReportTableColumn({
                        label: 'Taf',
                        selector: ReportColumnNames.TAF,
                        shifted: true
                    }),
                    new ReportTableColumn({
                        label: 'NSCC',
                        selector: ReportColumnNames.NSCC,
                        shifted: true
                    }),
                    new ReportTableColumn({
                        label: 'CLR',
                        selector: ReportColumnNames.CLR,
                        shifted: true
                    }),
                    new ReportTableColumn({
                        label: 'ORF',
                        selector: ReportColumnNames.ORF,
                        shifted: true
                    }),
                    new ReportTableColumn({
                        label: 'PTFPF',
                        selector: ReportColumnNames.PTFPF,
                        shifted: true
                    }),
                    new ReportTableColumn({
                        label: 'EFTT',
                        selector: ReportColumnNames.EFTT,
                        shifted: true
                    }),
                    new ReportTableColumn({
                        label: 'CAT',
                        selector: ReportColumnNames.CAT,
                        shifted: true
                    }),
                ],
                sortIndex: 9
            }),
            new ReportTableColumn({
                label: 'Net',
                selector: ReportColumnNames.Net,
                shifted: true,
                sortIndex: 10
            }),
            /**
             * Next Column sortIndex starts +1
             * because Adjustments Fees column
             * is dynamically created if there are Adjustments Fees
             */
            new ReportTableColumn({
                label: 'Adj Net',
                selector: ReportColumnNames.AdjNet,
                sortIndex: 12
            }),
            new ReportTableColumn({
                label: 'Transfers',
                selector: ReportColumnNames.Transfers,
                sortIndex: 13
            }),
            new ReportTableGroupedColumn({
                selector: 'EndBalance',
                label: 'End Balance',
                childColumns: [
                    new ReportTableColumn({
                        label: 'Cash',
                        selector: ReportColumnNames.Cash,
                        shifted: true
                    }),
                    new ReportTableColumn({
                        label: 'Unrealized',
                        selector: ReportColumnNames.Unrealized,
                        shifted: true
                    })
                ],
                sortIndex: 14
            }),
        ],
        hiddenColumnIds: [],
        disableColumnsOptions: true
    };
};
